exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-button[data-v-05b8d12a] {\n  margin: 0 auto;\n}\n@media only screen and (max-width: 600px) {\n.modal-header span[data-v-05b8d12a] {\n    margin-top: 20px;\n}\n}\n.change-method[data-v-05b8d12a] {\n  text-align: center;\n  text-decoration: underline;\n  color: #11bb2e;\n  margin: 5px 0 20px;\n}\n", ""]);

// exports
